import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';

import {selectTab} from '~/modules/tabs/actions';
import mapDispatch from '~/misc/mapDispatch';
import css from './tabs.css';
import {track} from '~/misc/metrics';

const trackTab = (name) => {
  track(name);
};

class Tabs extends React.Component {
  constructor(props) {
    super(props);
    this.renderTabs = this.renderTabs.bind(this);
  }

  render() {
    return (
      <div className={this.props.csTabWarp}>
        <div className={this.props.csTabs || css.tabs}>
          {this.props.tabs.map(this.renderTabs)}
        </div>
        <div className={this.props.csContents || css.tabContent}>
          {this.props.content[this.props.selected]}
        </div>
      </div>
    );
  }

  renderTabs({title, dataqa, id}) {
    return (
      <div
        className={cs(
          (this.props.csTab || css.tab),
          'qa-tab',
          `qa-tab-${id}`,
          {
            [this.props.csTabActive || css.tabActive]: id === this.props.selected,
            'qa-tab-active': id === this.props.selected,
          },
          css.tabHover
        )}
        onClick={this.props.select}
        data-id={id}
        key={`t${id}`}
        data-qa={`${dataqa}-tab`}
      >
        {title}
      </div>
    );
  }
}

export default connect((state, props) => (
  {selected: state.tabs[props.id] || props.tabs[0].id}
), mapDispatch({
  select: (props, e) => {
    const innerText = e.target.textContent;
    const trackTabArr = ['Saved', 'Hidden', 'Viewed'];
    if (trackTabArr.includes(innerText)) {
      trackTab(innerText);
    }
    if (props.clickFun) {
      props.clickFun(e.target.getAttribute('data-id'));
    }
    return selectTab(props.id, e.target.getAttribute('data-id'));
  },
}))(Tabs);



// WEBPACK FOOTER //
// ./src/components/tabs/tabs.js